import { render, staticRenderFns } from "./ColumnMappingsTable.vue?vue&type=template&id=559a179b&scoped=true&"
import script from "./ColumnMappingsTable.vue?vue&type=script&lang=js&"
export * from "./ColumnMappingsTable.vue?vue&type=script&lang=js&"
import style0 from "./ColumnMappingsTable.vue?vue&type=style&index=0&id=559a179b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559a179b",
  null
  
)

export default component.exports